import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, Facebook, MessageCircle } from 'lucide-react';

const LOGO_URL = "/logo-andeni.png";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61590294917178";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={LOGO_URL} 
              alt="AnDeni Time Solutions" 
              className="h-16 w-auto brightness-0 invert drop-shadow-lg"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Servicii profesionale pentru acte auto și documente oficiale. 
              Economisești timp, noi rezolvăm actele.
            </p>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-slate-400 hover:text-blue-400 transition-colors text-sm" data-testid="footer-facebook-link">
              <Facebook className="h-5 w-5" />
              Facebook
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Link-uri rapide</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/servicii" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-services-link">
                  Servicii
                </Link>
              </li>
              <li>
                <Link to="/comanda" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-order-link">
                  Comandă online
                </Link>
              </li>
              <li>
                <Link to="/despre-noi" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-about-link">
                  Despre noi
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/termeni-conditii" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-terms-link">
                  Termeni și condiții
                </Link>
              </li>
              <li>
                <Link to="/politica-confidentialitate" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-privacy-link">
                  Politica de confidențialitate
                </Link>
              </li>
              <li>
                <span className="text-slate-400 text-sm">
                  GDPR Compliant
                </span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:office@andeni-inmatriculari.ro" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-email">
                  office@andeni-inmatriculari.ro
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+40743121909" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-phone">
                  0743 121 909
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="h-5 w-5 text-green-400 mt-0.5 flex-shrink-0" />
                <a href="https://wa.me/40743121909" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-whatsapp">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">
                  Luni - Vineri: 09:00 - 18:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} AnDeni Time Solutions SRL. Toate drepturile rezervate.
            </p>
            <div className="flex items-center gap-4">
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-blue-400 transition-colors" title="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <p className="text-slate-500 text-sm">
                Servicii de intermediere documente auto
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
